import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone, FaWhatsapp } from 'react-icons/fa';
import logo from '../assets/wowlogo.jpeg';

const Navbar = () => {
  const { pathname } = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isHomePage = pathname === '/';
  const useSolidNavbar = !isHomePage || isScrolled;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/#home' },
    { name: 'About', href: '/#about' },
    { name: 'Fleet', href: '/#fleet' },
    { name: 'Destinations', href: '/#destinations' },
    { name: 'Testimonials', href: '/#testimonials' },
    { name: "FAQ's", href: '/#faq' },
    { name: 'Blogs', href: '/blog' },
    { name: 'Contact', href: '/#contact' },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        useSolidNavbar
          ? 'bg-white shadow-lg py-2'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <a href="/#home" className="flex items-center space-x-3 group">
          <img 
            src={logo} 
            alt="WOW Caravans Logo" 
            className="w-16 h-16 md:w-20 md:h-20 object-contain transition-transform group-hover:scale-105"
          />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className={`font-medium transition-colors hover:text-accent-500 ${
                useSolidNavbar ? 'text-primary-700' : 'text-white'
              }`}
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* Contact Buttons */}
        <div className="hidden md:flex items-center space-x-4">
          <a
            href="tel:+918380866111"
            className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-all hover:scale-105 whitespace-nowrap ${
              useSolidNavbar
                ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                : 'bg-white/20 text-white backdrop-blur-sm hover:bg-white/30'
            }`}
          >
            <FaPhone />
            <span className="font-semibold text-sm">+91 83808-66111</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden text-2xl ${useSolidNavbar ? 'text-primary-700' : 'text-white'}`}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg transition-all duration-300">
          <div className="container-custom py-6 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-primary-700 font-medium hover:text-accent-500 transition-colors py-2"
              >
                {link.name}
              </a>
            ))}
            <div className="flex flex-col space-y-3 pt-4 border-t">
              <a
                href="tel:+918380866111"
                className="flex items-center justify-center space-x-2 px-4 py-3 bg-primary-100 text-primary-700 rounded-full"
              >
                <FaPhone />
                <span className="font-semibold">+91 83808-66111</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
